import * as React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import colors from "../../theme/colors";
import Item from "../Shared/Style/StyledItem";

export default function Clientes() {
    const navigate = useNavigate();
  
    const NavigateTo = (path: string) => {
      navigate(path);
    }
    
    return(
      <Box sx={{ flexGrow: 1, p: { xs: 1, sm: 2 }, minHeight: { xs: "auto", md: "90vh" }, display: 'flex', flexDirection: 'column' }}>
      <Paper sx={{ p: { xs: 1, sm: 2 }, height: '100%', display: 'flex', flexDirection: 'column' }}>
          <Grid container spacing={2}>
            {/* Linha 1 - Cabeçalho e Descrição */}
            <Grid item xs={12}> 
              <Paper sx={{ p: 1, bgcolor: '#f8f9fa' }}>
                <h4 style={{ margin: '0 0 0 0', color: colors.bluePrimary, textAlign: 'left' }}>
                  👥 Gestão de Clientes
                </h4>
                <Typography variant="body2" sx={{ color: '#666', mt: 1 }}>
                  Cadastro e consulta de clientes
                </Typography>
              </Paper>
            </Grid>

            {/* Linha 2 - Cards de Navegação */}
            <Grid item xs={12}>
                <Grid container spacing={2}>
                  {/* Card - Cadastrar Clientes */}
                  <Grid item xs={12} sm={6} md={6}>
                    <Item onClick={() => NavigateTo("../cadastrarclientes")}>
                      <Box sx={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center',
                        p: 1
                      }}>
                        <PersonAddAlt1Icon
                          sx={{ 
                            color: colors.accent, 
                            fontSize: '2.5em',
                            mb: 1
                          }}
                        />
                        <Typography variant="h6" sx={{ color: colors.bluePrimary, fontWeight: 'bold', mb: 1 }}>
                          Cadastrar Clientes
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#666', textAlign: 'center' }}>
                          Cadastro de novos clientes no sistema
                        </Typography>
                      </Box>
                    </Item>
                  </Grid>

                  {/* Card - Consultar Clientes */}
                  <Grid item xs={12} sm={6} md={6}>
                    <Item onClick={() => NavigateTo("../consultarclientes")}>
                      <Box sx={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center',
                        p: 1
                      }}>
                        <PersonSearchIcon
                          sx={{ 
                            color: colors.accent, 
                            fontSize: '2.5em',
                            mb: 1
                          }}
                        />
                        <Typography variant="h6" sx={{ color: colors.bluePrimary, fontWeight: 'bold', mb: 1 }}>
                          Consultar Clientes
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#666', textAlign: 'center' }}>
                          Consulta de clientes existentes
                        </Typography>
                      </Box>
                    </Item>
                  </Grid>
                </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    )
}